import {SearchResultsComponent as BaseComponent} from "lemans-brandsites-common/components/SearchResults/SearchResults.component";
import * as React from 'react';
import './SearchResults.styles.less';
import {SearchResultsProps} from "./SearchResults.types";

export const SearchResultsComponent = (props:SearchResultsProps) => <BaseComponent {...props} />;
